export default __webpack_public_path__ + "static/media/dji.6d106575.jpg";